
import { mapActions, mapGetters, mapState } from 'vuex'
import LoadingContainer from '@/components/ui/LoadingContainer.vue'
import LandingMyAdItem from '@/components/landing/LandingMyAdItem.vue'
import LandingAllNewOnboarding from '@/components/landing/LandingAllNewOnboarding.vue'

export default {
  updateTriggerTimeoutId: undefined,
  components: {
    LoadingContainer,
    LandingMyAdItem,
    LandingAllNewOnboarding
  },
  props: {
    thisEntityId: {
      type: Number,
      required: false,
      default: null
    },
    createNew: {
      type: Boolean,
      required: false,
      default: false
    },
    section: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      attributeInputValues: null,
      confirmationDialog: {
        title: null,
        subtitle: null
      },
      isSubmitting: false,
      loginOverlay: false

    }
  },
  async fetch () {
    const promises = [
      this.getStepper(),
      this.getAttributes(),
      this.getAttributesDe(),
      this.getCustomerAttributes(),
      this.getMerchantAttributes()

    ]
    if (!this.$auth.loggedIn) {
      promises.push(this.getPublicCustomer())
    }

    await Promise.all(promises)
    // await Promise.all(promises)
    // if (!this.$auth.loggedIn) {
    //   await this.getPublicCustomer()
    // }

    if (this.product?.entityId && !this.$auth.loggedIn) {
      await this.$store.dispatch('customer/getOwner', this.product.entityId)
    }
  },

  computed: {
    ...mapState({
      product: state => state.upload.product,
      attributes: state => state.upload.attributes,
      attributesDe: state => state.upload.attributesDe,
      customer: state => state.customer.customer,
      customerAttributes: state => state.customer.customerAttributes,
      productTypeOptionIds: state => state.upload.productTypeOptionIds
    }),
    ...mapGetters({ isNlDomain: 'isNlDomain' }),
    entityId () {
      return this.product?.entityId
    },

    showStepper () {
      if (this.thisEntityId) {
        return true
      }

      const unsubmittedFunnnel20ProductId = this.$cookies.get('funnel_20_unsubmitted')
      if (this.entityId === unsubmittedFunnnel20ProductId || unsubmittedFunnnel20ProductId === -1) {
        return true
      }

      return this.entityId === null
    },
    pending () {
      return this.$fetchState.pending
    }

  },
  methods: {
    ...mapActions('customer', ['getCustomer', 'getAds', 'getCustomerAttributes', 'getMerchantAttributes', 'getPublicCustomer']),
    ...mapActions('upload', [
      'getOnboardingStepperData',
      'getAttributes',
      'getAttributesDe',
      'deleteAttributeByCode',
      'postGetConditionallyRequiredAttributes'
    ]),

    async getStepper () {
      await this.$store.dispatch('upload/getOnboardingStepperData', {
        entityId: this.thisEntityId,
        createNew: this.createNew
      })
      await this.postGetConditionallyRequiredAttributes()
    }

  }
}
